import { render } from "./WhatWeDoBest.vue?vue&type=template&id=6f99a62c&scoped=true"
import script from "./WhatWeDoBest.vue?vue&type=script&lang=ts"
export * from "./WhatWeDoBest.vue?vue&type=script&lang=ts"

import "./WhatWeDoBest.vue?vue&type=style&index=0&id=6f99a62c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f99a62c"

export default script